<template>
    <div>
        <h5 class="mt-1 mb-4">{{ $t('university_informations').toUpper() }}</h5>
        <b-card class="soft mb-5">
            <b-row>
                <b-col cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('academic_year_of_registration') }}</label>
                        <div>
                            <span>{{ getObjectValue(studentProgram, 'registration_semester_academic_year') }} </span>
                            <span>&nbsp;-&nbsp;</span>
                            <span>{{ studentProgram.registration_semester ? this.getSemester(studentProgram.registration_semester) : '-' }}</span>
                        </div>
                    </div>
                </b-col>
                <b-col cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('registration_date') }}</label>
                        <div>{{ studentProgram.registration_date ? this.toLocaleDate(studentProgram.registration_date) : '-' }}</div>
                    </div>
                </b-col>
                <b-col cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('registration_type') }}</label>
                        <div>{{ studentProgram.registration_type_text }}</div>
                    </div>
                </b-col>
                <b-col cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('legal_presence_type') }}</label>
                        <div>{{ studentProgram.legal_presence_type }}</div>
                    </div>
                </b-col>
                <b-col cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('student_status') }}</label>
                        <div>{{ studentProgram.student_status_text }}</div>
                    </div>
                </b-col>
                <b-col cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('semester_status') }}</label>
                        <div>{{ studentProgram.semester_status_name }}</div>
                    </div>
                </b-col>
                <b-col cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('class') }}</label>
                        <div>{{ studentProgram.class_name }}</div>
                    </div>
                </b-col>
                <b-col cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('credit_transfer') }}</label>
                        <div>{{ studentProgram.credit_transfer }}</div>
                    </div>
                </b-col>
                <b-col cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('re_enrollment') }}</label>
                        <div>{{ studentProgram.re_enrollment }}</div>
                    </div>
                </b-col>
                <b-col cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('credit_type') }}</label>
                        <div>{{ studentProgram.credit_type }}</div>
                    </div>
                </b-col>
                <b-col cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('change_of_program') }}</label>
                        <div>{{ studentProgram.change_of_program }}</div>
                    </div>
                </b-col>
                <b-col cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('minor_program') }}</label>
                        <div>{{ studentProgram.minor_program_name }}</div>
                    </div>
                </b-col>
                <b-col cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('transfer_out_destination') }}</label>
                        <div>{{ studentProgram.to_university_name }}</div>
                    </div>
                </b-col>

                <b-col cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('program_path') }}</label>
                        <div>{{ formatProgramPath(studentProgram.program_path) }}</div>
                    </div>
                </b-col>
                <b-col cols="6">
                    <div class="label-as-input-div">
                        <label>{{ $t('Concentration') }}</label>
                        <div>{{ studentProgram.program_expertise_name }}</div>
                    </div>
                </b-col>
                <b-col cols="6" v-if="studentProgram.program_path === 'Professional Hybrid'">
                    <div class="label-as-input-div">
                        <label>{{ $t('professional_hybrid_semester') }}</label>
                        <div>{{ studentProgram.professional_hybrid_semester_start_name }}</div>
                    </div>
                </b-col>
            </b-row>
        </b-card>
        <b-row>
            <b-col cols="12" lg="6">
                <b-card :header="$t('graduation_information')" class="soft mb-5">
                    <b-row>
                        <b-col cols="6" lg="12">
                            <div class="label-as-input-div">
                                <label>{{ $t('graduation_semester') }}</label>
                                <div>
                                    {{ getObjectValue(studentProgram, 'graduation_semester_academic_year','') }}
                                    -
                                    {{ studentProgram.graduation_semester_semester ? this.getSemester(studentProgram.graduation_semester_semester) : '' }}
                                </div>
                            </div>
                        </b-col>
                        <b-col cols="6" lg="12">
                            <div class="label-as-input-div">
                                <label>{{ $t('graduation_decision_date') }}</label>
                                <div>{{ studentProgram.graduation_date ? this.toLocaleDate(studentProgram.graduation_date) : '-' }}</div>
                            </div>
                        </b-col>
                        <b-col cols="6" lg="12">
                            <div class="label-as-input-div">
                                <label>{{ $t('graduation_decision_number') }}</label>
                                <div>{{ getObjectValue(studentProgram, 'graduation_decision_number') }}</div>
                            </div>
                        </b-col>
                        <b-col cols="6" lg="12">
                            <div class="label-as-input-div">
                                <label>{{ $t('latin_honors') }}</label>
                                <div>{{ getObjectValue(studentProgram, 'latin_honors') }}</div>
                            </div>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
            <b-col cols="12" lg="6">
                <b-card :header="$t('diploma_information')" class="soft mb-5">
                    <b-row>
                        <b-col cols="6" lg="12">
                            <div class="label-as-input-div">
                                <label>{{ $t('diploma_status') }}</label>
                                <div>{{ studentProgram.diploma_status_name }}</div>
                            </div>
                        </b-col>
                        <b-col cols="6" lg="12">
                            <div class="label-as-input-div">
                                <label>{{ $t('diploma_date') }}</label>
                                <div>{{ studentProgram.diploma_date ? this.toLocaleDate(studentProgram.diploma_date) : '-' }}</div>
                            </div>
                        </b-col>
                        <!--
                        <b-col cols="6" lg="12">
                            <div class="label-as-input-div">
                                <label>{{ $t('diploma_supplement') }}</label>
                                <div>-</div>
                            </div>
                        </b-col>
                        -->
                        <b-col cols="6" lg="12">
                            <div class="label-as-input-div">
                                <label>{{ $t('diploma_number') }}</label>
                                <div>{{ getObjectValue(studentProgram, 'diploma_number') }}</div>
                            </div>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
            <b-col cols="12" lg="6">
                <b-card :header="$t('leaving_information')" class="soft mb-5">
                    <b-row>
                        <b-col cols="6" lg="12">
                            <div class="label-as-input-div">
                                <label>{{ $t('reason_for_leaving') }}</label>
                                <div>
                                    {{ studentProgram.leaving_reason_name }}
                                </div>
                            </div>
                        </b-col>
                        <b-col cols="6" lg="12">
                            <div class="label-as-input-div">
                                <label>{{ $t('leaving_semester') }}</label>
                                <div>
                                    {{ getObjectValue(studentProgram, 'leaving_semester_academic_year','') }}
                                    -
                                    {{ studentProgram.leaving_semester_semester ? this.getSemester(studentProgram.leaving_semester_semester) : '' }}
                                </div>
                            </div>
                        </b-col>
                        <b-col cols="6" lg="12">
                            <div class="label-as-input-div">
                                <label>{{ $t('leaving_date') }}</label>
                                <div>{{ studentProgram.leaving_date ? studentProgram.leaving_date: '-' }}</div>
                            </div>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>

        <b-button variant="primary"
                  @click="updateFormShow"
                  v-if="checkPermission('studentprogram_update') && editMode">
            {{ $t('edit') }}
        </b-button>

        <CommonModal ref="formModal" size="xxl"
                     :onHideOnlyX="true"
                     @bHideModalHeaderClose="clearFormData()"
                     v-if="checkPermission('studentprogram_update') && editMode">
            <template v-slot:CommonModalTitle>
                {{ $t('edit').toUpper() }}
            </template>
            <template v-slot:CommonModalContent>
                <update-form :studentProgram="studentProgram"
                             @updateFormSuccess="updateFormSuccess()"
                             v-if="formProcess=='update'"
                />
            </template>
        </CommonModal>
    </div>
</template>
<script>
    // Component
    import CommonModal from '@/components/elements/CommonModal';

    // Update Form
    import UpdateForm from './UpdateForm';

    export default {
        components: {
            CommonModal,
            UpdateForm
        },
        props: {
            studentProgram: {
                type: Object,
                default: null
            },
            editMode: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                formProcess: null
            }
        },
        methods: {
            // Clear
            clearFormData() {
                this.formProcess = null
            },

            // Update
            updateFormShow() {
                this.formProcess = 'update'
                this.$refs.formModal.$refs.commonModal.show()
            },
            updateFormSuccess() {
                this.clearFormData();
                this.$refs.formModal.$refs.commonModal.hide()
                this.$emit('updatedData', true);
            },
            formatProgramPath(value) {
                if (value === 'Traditional') {
                    return this.$t('traditional');
                } else if (value === 'Professional Hybrid') {
                    return this.$t('professional_hybrid');
                } else {
                    return '-';
                }
            }
        }
    }
</script>

